module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/smarthome-856e5a5e8900f1dee429422b84569b9d.jpg";